import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-dialog-delete-product',
  templateUrl: './dialog-delete-product.component.html',
  styleUrls: ['./dialog-delete-product.component.css']
})
export class DialogDeleteProductComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private productsService: ProductsService) { }

  onDelete(ID) {
    this.productsService.deleteProduct(ID);
  }
}
